export function aboutUsValidation(field) {

    // return
    const errors = {
        headerSection: {
            section: {
            },
            pageTitle: ""
        },
        bottomSection: {
            section: {},
            pageTitle: ""
        },
        topicSection: {
            section: [],
            pageTitle: ""
        },
        faq: {
            section: [],
        },
        metaProperties: {
            title: "",
            description: ""
        }
    };
    // Example validation rules:
    if (field?.headerSection?.status) {
        if (!field?.headerSection?.pageTitle?.trim()) {
            errors.headerSection.pageTitle = "Title is required";
        }
        if (!field?.headerSection?.section?.description?.trim()) {
            errors.headerSection.section.description = "Description is required";
        }
        // if (!field?.headerSection?.section?.image?.url) {
        //     errors.headerSection.section.image.url = "Image is required";
        // }
        if (!field?.headerSection?.section?.image || !field.headerSection.section.image.url?.trim()) {
            errors.headerSection.section.image = {
                ...(errors.headerSection.section.image || {}), // Ensure image object exists
                url: "Image  is required",
            };
        }
    }

    // bottom section

    if (field?.bottomSection?.status) {
        if (!field?.bottomSection?.pageTitle?.trim()) {
            errors.bottomSection.pageTitle = "Title is required";
        }

        if (!field?.bottomSection?.section?.description?.trim()) {
            errors.bottomSection.section.description = "Description is required";
        }

        // if (!field?.bottomSection?.section?.image?.url) {
        //     errors.bottomSection.section.image?.url = "Image is required";
        // }

        if (!field?.bottomSection?.section?.cta) {
            errors.bottomSection.section.cta = "CTA is required";
        }
        if (!field?.bottomSection?.section?.url) {
            errors.bottomSection.section.url = "CTA Link is required";
        }
        if (field?.bottomSection?.section?.url && !validURL(field?.bottomSection?.section?.url)) {
            errors.bottomSection.section.url = "Invalid link: must start with http:// or https://";
        }
    }

    if (field?.topicSection?.status) {
        if (!field?.topicSection?.pageTitle?.trim()) {
            errors.topicSection.pageTitle = "Title is required";
        }
        if (field?.topicSection?.section?.length > 0) {
            field.topicSection.section.forEach((banner, index) => {
                const bannerErrors = {};
                if (!banner.title?.trim()) {
                    bannerErrors.title = "Title is required";
                } else if (banner.title.length > 80) {
                    bannerErrors.title = "Character limit exceeded.";
                }

                // Check for description
                if (!banner.description?.trim()) {
                    bannerErrors.description = "Description is required";
                } else if (banner.description.length > 500) {
                    bannerErrors.description = "Character limit exceeded.";
                }

                // Check for imageUrl
                // if (!banner.image?.url) {
                //     bannerErrors.image.url = "Image is required";
                // }
                // Check for image object and its properties
                if (!banner.image || !banner.image.url?.trim()) {
                    bannerErrors.image = {
                        ...(bannerErrors.image || {}), // Ensure image object exists
                        url: "Image  is required",
                    };
                }
                // Add banner-level errors to the topicSection errors array
                if (Object.keys(bannerErrors).length > 0) {
                    errors.topicSection.section[index] = bannerErrors;
                }
            });

            // **Validate platformAvailability - At least one should be true**
            if (!Object.values(field?.platformAvailability || {}).includes(true)) {
                errors.platformAvailability = "At least one platform must be selected.";
            }

            // **Validate displaySettings - At least one should be true**
            if (!Object.values(field?.displaySettings || {}).includes(true)) {
                errors.displaySettings = "At least one display option must be selected.";
            }

        }
    }

    if (field?.faq?.status) {
        if (field?.faq?.section?.length > 0) {
            field.faq.section.forEach((banner, index) => {
                const bannerErrors = {};
                // Check for description
                if (!banner.question?.trim()) {
                    bannerErrors.question = "question is required";
                }
                if (!banner.answer?.trim()) {
                    bannerErrors.answer = "answer is required";
                }

                // Add banner-level errors to the topicSection errors array
                if (Object.keys(bannerErrors).length > 0) {
                    errors.faq.section[index] = bannerErrors;
                }
            });


        }
    }

    if (!field?.metaProperties?.title?.trim()) {
        errors.metaProperties.title = "Meta Title is required";
    }

    if (!field?.metaProperties?.description?.trim()) {
        errors.metaProperties.description = "Meta Description is required";
    }



    return {
        errors,
        isValid:
            Object.keys(errors.headerSection.section).length === 0 &&
            Object.keys(errors.bottomSection.section).length === 0 &&
            Object.keys(errors.topicSection.section).every(
                (key) => Object.keys(errors.topicSection.section[key]).length === 0
            ) &&
            Object.keys(errors.faq.section).every(
                (key) => Object.keys(errors.faq.section[key]).length === 0
            ) &&
            Object.keys(errors.metaProperties).length === 0 &&
            errors.platformAvailability === "" &&
            errors.displaySettings === "",
    };
}

export function ReviewValidation(field) {

    // return
    const errors = {
        headerSection: {
            section: {
            },
            pageTitle: ""
        },

        metaProperties: {
            title: "",
            description: ""
        }
    };
    // Example validation rules:
    if (field?.headerSection?.status) {
        if (!field?.headerSection?.pageTitle?.trim()) {
            errors.headerSection.pageTitle = "Title is required";
        }
        if (!field?.headerSection?.section?.description?.trim()) {
            errors.headerSection.section.description = "Description is required";
        }
    }


    if (!field?.metaProperties?.title?.trim()) {
        errors.metaProperties.title = "Meta Title is required";
    }

    if (!field?.metaProperties?.description?.trim()) {
        errors.metaProperties.description = "Meta Description is required";
    }

    // **Validate displaySettings - At least one should be true**
    if (!Object.values(field?.displaySettings || {}).includes(true)) {
        errors.displaySettings = "At least one display option must be selected.";
    }


    return {
        errors,
        isValid:
            Object.keys(errors.headerSection.section).length === 0 &&
            Object.keys(errors.metaProperties).length === 0 &&
            errors.platformAvailability === "" &&
            errors.displaySettings === "",
    };
}

// export const validURL = (url) => {
//     const urlPattern = /^(https?:\/\/)([\w.-]+)\.([a-z]{2,6})([/\w .-]*)*\/?$/i;
//     return urlPattern.test(url);
// };
export const validURL = (url) => {
    const urlPattern = new RegExp(
        '^(https?:\\/\\/)?' +                    // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,})' + // domain name
        '(\\:\\d+)?' +                           // port
        '(\\/[-a-z\\d%@_.~+&:]*)*' +             // path
        '(\\?[;&a-z\\d%@_.,~+&:=-]*)?' +         // query string
        '(\\#[-a-z\\d_]*)?$',                    // fragment
        'i'
    );
    return !!urlPattern.test(url);
};